import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { SecurityGroup } from '../../entities/management/security-group.entity';
import { AbstractHttpService } from '../http/http-service.abstract';

@Injectable()
export class SecurityGroupService {
    private readonly ENDPOINT: string = 'security-groups';

    constructor(private httpService: AbstractHttpService) {}

    getAll(): Observable<SecurityGroup[]> {
        return this.httpService.get(this.ENDPOINT);
    }

    getSingle(id: string): Observable<SecurityGroup> {
        return this.httpService.get(`${this.ENDPOINT}/${id}`);
    }

    create(securityGroup: SecurityGroup): Observable<SecurityGroup> {
        return this.httpService.post(`${this.ENDPOINT}`, securityGroup);
    }

    update(securityGroup: SecurityGroup): Observable<SecurityGroup> {
        return this.httpService.put(`${this.ENDPOINT}/${securityGroup.Id}`, securityGroup);
    }

    delete(id: string): Observable<void> {
        return this.httpService.delete(`${this.ENDPOINT}/${id}`);
    }
}
